<template>
	<div>
		<h1 class="text-2xl font-bold md:text-4xl">KONTAKT</h1>
		<p class="pt-4 text-base md:text-lg">Der EnergieKompass ist ein Service des Landes Salzburg.</p>

		<p class="text-base md:text-lg">Wir helfen Ihnen bei Ihren Anliegen, Wünschen oder Anregungen:</p>
		<div class="pt-8">
			<p class="text-base text-land-red md:text-2xl">
				<strong>Land Salzburg</strong>
			</p>

			<p class="md:text-ml">
				<strong>Referat Energiewirtschaft und -beratung </strong>
			</p>
			<p>Adresse: Postfach 527 | 5010 Salzburg</p>
			<p>
				Email:
				<a href="mailto:energiekompass@salzburg.gv.at" class="underline">energiekompass@salzburg.gv.at</a>
			</p>
		</div>
	</div>
</template>
